/* eslint-disable import/prefer-default-export */
import { css } from "@emotion/react";

export const paginationWrapperCss = css`
  margin-top: 16px;
`;

export const tableContainerCss = css`
  padding: 16px;
  background: white;
`;
